<script>
	import BorderedContent from './BorderedContent.vue';
	import BorderedTwoColumn from './BorderedTwoColumn.vue';
	import CenteredTwoColumn from './CenteredTwoColumn.vue';
	import FullBgImage from './FullBgImage.vue';
	import BgImageTwoColumn from './BgImageTwoColumn.vue';
	import TwoColumnBg from './TwoColumnBg.vue';
	import {disableDefaultScroll, enableDefaultScroll} from '../util.js';

	export default {

		name: 'factory',
		props: {
			template: String,
			content: Object,
			id: String,
			viewIndex: Number,
			index: Number,
			count: Number,
			activeView: Number,
			activeSlide: Number,
			transitioning: Boolean
		},
		render(createElement) {
			let temp;
			switch(this.template){
				case 'borderedContent':
					temp = BorderedContent;
					break;
				case 'borderedTwoColumn':
					temp = BorderedTwoColumn;
					break;
				case 'centeredTwoColumn':
					temp = CenteredTwoColumn;
					break;
				case 'fullBgImage':
					temp = FullBgImage;
					break;
				case 'bgImageTwoColumn':
					temp = BgImageTwoColumn;
					break;
				case 'twoColumnBg':
					temp = TwoColumnBg;
					break;
			}
			return createElement(temp, 
				{
					props: {
						page: this.id,
						indexValue: this.indexValue,
						countValue: this.countValue,
						index: this.index,
						count: this.count,
						classes: [
									this.id,
									'slide slide-' + this.index,
									this.id + '-' + this.index,
									{active: this.index === this.activeSlide}
									],
						finishTransition: this.finishTransition,
						changeSlide: this.changeSlide,
						...this.content}
				});
		},
		computed: {
			indexValue: function(){
				if(this.id === 'experience' || this.id === 'sound'){
					return this.index - 1;
				} else if(this.id === 'neighbor'){
					return this.index - 2;
				}else {
					return this.index
				}
			},
			countValue: function() {
				if(this.id === 'sound'){
					return this.count - 3;
				} else if(this.id === 'experience'){
					return this.count - 1;
				} else if(this.id === 'neighbor'){
					return this.count - 2;
				}else {
					return this.count
				}
			}
		},
		mounted() {
			//TRANSITION IN FIRST SLIDE FROM VIEW CONTAINER
			if(this.index == this.activeSlide){
				disableDefaultScroll()
				this.$children[0].transitionIn(1);
			}
		},
		watch: {
			activeView: function(newVal, oldVal) {
				// console.log("view", newVal, oldVal)

			},
			activeSlide: function(newVal, oldVal) {
				console.log("NEW SLIDE FOR", this.id, newVal)
				if(this.viewIndex !== this.activeView){
					// console.log("LET IT BEEEEEE");
				} else if(newVal == this.index && !this.transitioning){
					// console.log("NEW SLIDE COMINNG IN", newVal, oldVal, this.viewIndex, this.activeView)
					disableDefaultScroll()
					let dir = newVal > oldVal ? 1 : -1
					this.$children[0].transitionIn(dir)
				} else if(oldVal === this.index){
					// console.log("TRANS SLIDE OUT")
					this.$children[0].transitionOut()
				}
			}
		},
		methods: {
			finishTransition: function() {
				this.$emit('clearTransitioning');
				enableDefaultScroll();
			},
			changeSlide: function(){
				this.$emit('changeSlide')
			}
		}
	} 
</script>

<style lang="scss">
	.slide{
		position: absolute;
		width: 100%;
		height: 100%;
	}
</style>